module.exports = __webpack_public_path__ + "static/media/Lato-BoldItalic.0b6bb672.woff2";